export const ENHANCEMENT_MODE = {
  OFF: 'off',
  AUTO: 'auto',
};

export const IMG_FILTERS = {
  BRIGHTNESS: 'filterBrightness',
  CONTRAST: 'filterContrast',
  SATURATION: 'filterSaturation',
};
